module.exports = __webpack_public_path__ + "img/whatsapp.d6e2a21f.svg";